import React from "react";
import "./Header.css";

const Header = () => {
  return (
    <div className="row header">
      <div className="col-md-12">
        <h1 className="h1" style={{ color: "#ffffff" }}>
          Password Generator
        </h1>
      </div>
      <div className="col-md-12">
        <h4 style={{ fontWeight: "300" }}>
          Create strong passwords with our generator
        </h4>
      </div>
    </div>
  );
};

export default Header;
